// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    PRODUCT_PAGE_LOADING() {
      return {
        isLoading: true,
        productPage: action.productPage
      };
    },
    PRODUCT_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.homepage
      };
    },
    PRODUCT_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
